export const DMI_FINANCE_APIS = {
  GET_PLAN_URL: "https://portal.acrossassist.com/api/partner/v1/dmi/GetPlan",
  GET_BRAND_LIST_URL:
    "https://portal.acrossassist.com/api/partner/v1/dmi/GetBrands",
  SAVE_DMI_DETAILS_URL:
    "https://portal.acrossassist.com/api/partner/v1/dmi/SaveDMIDetails",
  SEND_DMI_PAYMENT_REQUEST_URL:
    "https://portal.acrossassist.com/api/partner/v1/dmi/SendDMIPayemtRequest",
  GET_DMI_PAYMENT_STATUS_URL:
    "https://portal.acrossassist.com/api/partner/v1/dmi/GetPaymentStatusByUserId",
};
